// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

interface SetActiveStepFunction<T> {
  (updateFunction: (prevActiveStep: T) => T): void;
}
interface CloseConfirmationModalProps {
  openConfirmationModal: boolean;
  setOpenConfirmationModal: (value: boolean) => void;
  handleClose: () => void;
  resetActiveStep?: SetActiveStepFunction<number>;
}

const CloseConfirmationModal = ({
  openConfirmationModal,
  setOpenConfirmationModal,
  handleClose,
  resetActiveStep,
}: CloseConfirmationModalProps) => {
  return (
    <Dialog open={openConfirmationModal} fullWidth maxWidth="xs">
      <DialogTitle variant="inherit">
        <b>Close the form</b>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 1 }} variant="standard">
          Are you sure you want to close this form?
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpenConfirmationModal(false);
          }}
          color="primary"
          variant="outlined"
          size="small"
        >
          No
        </Button>
        <Button
          color="primary"
          variant="contained"
          size="small"
          onClick={() => {
            handleClose();
            setOpenConfirmationModal(false);
            resetActiveStep && resetActiveStep(() => 0);
          }}
        >
          yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloseConfirmationModal;
